import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { colors, layout } from 'Constants';
import { capital } from 'case';

import {
  Container,
  Header,
  Icon,
  Anchor,
  Button,
  Footnote
} from 'Components/core';
import Table from 'Components/Table/TableAlt';

// State
import { ApiStore, Subscribe } from 'Store';

import InfoBox from 'Components/InfoBox';
import ReadyToEnroll from 'Views/benefits/components/ReadyToEnroll';

// Images
import BlueView from './images/Vision_Benefits_-_Blue_View_Vision.jpeg';
import VisionCompanies from './images/visioncompanies@2x.png';
import CODES from 'Root/libs/analytics/CodeDef';
import Api from 'Root/libs/analytics/Api';
import { replaceAnchor } from 'Root/libs/anchor';
import {
  HeaderV2,
  SubHeader,
  TitleHeader,
  TitleHeader2
} from 'Components/core/Header';
import PaddedContainer from 'Components/core/PaddedContainer';

export default props => {
  const [headers, setHeaders] = useState([]);
  const [rows, setRows] = useState([]);

  const updateTable = () => {
    const state = ApiStore.get();
    if (typeof state.vision?.visionPlanChart !== 'object') return;

    const chartData = { ...state.vision.visionPlanChart };

    setHeaders(['', chartData['headerVision']]);
    delete chartData['headerVision'];

    const values = Object.values(chartData);
    const keys = Object.keys(chartData);

    console.log(keys);
    console.log(values);
    const labelMap = {
      eyeExams: 'Routine eye exam',
      eyeglassFrames: 'Eyeglass frames',
      eyeglassLenses: 'Eyeglass lenses ',
      disposableContacts: 'Disposable contacts',
      nondisposableContacts: 'Non-disposable contacts'
    };

    setRows([...values.map((val, i) => [labelMap[keys[i]], val])]);
  };

  ApiStore.subscribe(updateTable);

  useEffect(() => {
    Api.recordAcitity(CODES.MENU_VISION_BENIFITS);
    updateTable();
  }, []);

  return (
    <Subscribe to={[ApiStore]}>
      {state => (
        <Container
         
          column
          maxWidth
          style={{ margin: 'auto' }}
        >
          <HeaderV2
            title={'Vision Benefits'}
            text={
              <>
                Routine eye checkups go beyond making sure you can see clearly.
                They also can catch other health problems early, like diabetes,
                high blood pressure, high cholesterol and rheumatoid arthritis.
                <sup>1</sup> So when you choose a vision plan, you're supporting
                your overall health.
              </>
            }
          ></HeaderV2>

          <PaddedContainer style={{marginTop:40}} column header="Blue View Vision" image={BlueView}>
            <TitleHeader2>Blue View Vision</TitleHeader2>
            {!state.vision?.summary && (
              <div>
                <p>
                  When you choose Blue View Vision, you'll be covered for
                  checkups and eye exams, and you'll get allowances for the
                  glasses or contacts you rely on.
                </p>
              </div>
            )}
            {state.vision?.summary && (
              <div>
                <p
                  dangerouslySetInnerHTML={{
                    __html: replaceAnchor(state.vision?.summary)
                  }}
                ></p>
              </div>
            )}

            <VisionContainer>
              {state.vision?.highlights && (
                <div>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: replaceAnchor(state.vision?.highlights)
                    }}
                  ></p>
                </div>
              )}
              {!state.vision?.highlights && (
                <div>
                  {' '}
                  <p>Your vision benefits include:</p>
                  <ul>
                    <li>Adult routine eye exams.</li>
                    <li>
                      Frames and either eyeglass lenses or contact lenses for
                      adults.
                    </li>
                    <li>Routine pediatric eye exams.</li>
                    <li>
                      Frames and either eyeglass lenses or contact lenses for
                      children on your plan up to age 19; includes protective
                      Transitions lenses or polycarbonate lenses at no extra
                      cost.
                    </li>
                    <li>
                      International Travel Solution for care and support when
                      you're traveling outside the U.S. <sup>2</sup>
                    </li>
                    <li>
                      Access to more than 38,000 eye doctors and
                      eyeglass/contact specialists at more than 27,000 locations
                      across the country, including names you know:
                    </li>
                  </ul>
                </div>
              )}
            </VisionContainer>
            <img style={{marginTop:40,marginBottom:40}} alt="List of Vision companies" src={VisionCompanies} />
            <Table headers={headers} rows={rows} />
            <Footnote
              dangerouslySetInnerHTML={{
                __html: state.vision?.visionDisclosure
              }}
            ></Footnote>
          </PaddedContainer>
          {false && <ReadyToEnroll />}

          <Footnote>
            {state.vision?.footNotes && (
              <p
                dangerouslySetInnerHTML={{
                  __html: replaceAnchor(state.vision?.footNotes)
                }}
              ></p>
            )}
            {!state.vision?.footNotes && (
              <React.Fragment>
                {' '}
                <p>
                  <sup>1</sup> American Optometric Association website,
                  Evidence-Based Clinical Practice Guideline, Comprehensive
                  Adult Eye and Vision Examination 2015 (accessed February
                  2019):{' '}
                  <Anchor code={CODES.VN_BFT_AOA} to="https://www.aoa.org">
                    aoa.org.
                  </Anchor>
                </p>
                <p>
                  <sup>2</sup> Available in Australia, Austria, Brazil, Canada,
                  Chile, China, Colombia, Ecuador, England, France, Germany,
                  Hong Kong SAR, Italy, Japan, Mexico, New Zealand, Peru, Puerto
                  Rico U.S., Spain, and Switzerland.
                </p>
              </React.Fragment>
            )}
          </Footnote>
        </Container>
      )}
    </Subscribe>
  );
};

const VisionContainer = styled.div`
  display: flex;
  align-self:center ;
  
  >div{
  max-width:90%;
  padding:20px;
 
border-radius: 8px;
background: #fff;
border: 0px solid #eee;

  }
`;
